<template>
  <div class="fund-result">
    <MoreTitle title="业绩表现" @click="goPage" />
    <RkSwitch v-model="activeTab" :options="options" />
    <RkTable :data="fundResultData" :show-footer="false">
      <RkTableColumn prop="" label="日期" align="left"></RkTableColumn>
      <RkTableColumn prop="" label="涨跌幅"></RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import RkSwitch from '@/components/common/RkSwitch.vue'
export default {
  components: { RkSwitch },
  data() {
    return {
      fundResultData: [],
      activeTab: '历史业绩',
      options: Object.freeze([
        [
          {
            label: '历史业绩',
            value: '历史业绩'
          },
          {
            label: '历史净值',
            value: '历史净值'
          }
        ]
      ])
    }
  },
  methods: {
    goPage() {
      this.$router.push({
        path: '/etf/result',
        query: {
          symbol: this.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fund-result {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
}
</style>
